import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import SpinLoader from '../../crm/shared/field_inputs/shared/SpinLoader';
import { useTranslation } from 'react-i18next';
import { CLOSE } from '../../../i18n/keyConstants';

const CustomModal = ({ onHide, handleModal, show, modalText, buttonText, buttonClassName, modalVariant, isSaving }) => {
    const { t } = useTranslation(['shared']);
    return (
        <Modal show={show} onHide={onHide} size='sm' centered>
            <Modal.Body>{modalText}</Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={onHide}>
                  {t(CLOSE)}
                </Button>
                <div className='exl-action-buttons-container-modal'>
                <Button className={buttonClassName} variant={modalVariant} onClick={handleModal}>
                    <div className={isSaving ? 'invisible' : ''}>{buttonText}</div>
                    <SpinLoader isLoading={isSaving} size={'20px'} />
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default CustomModal;
